<button
  *ngIf="minimizedCount > 0"
  type="button"
  class="compose-minimized-bar"
  (click)="restore()"
  [attr.aria-label]="minimizedCount === 1 ? ('smart_inbox.inbox_view.compose_minimized_bar.aria_label_one' | translate) : ('smart_inbox.inbox_view.compose_minimized_bar.aria_label_many' | translate:{ count: minimizedCount })"
  [matTooltip]="'smart_inbox.inbox_view.compose_minimized_bar.tooltip_restore_all' | translate"
  matTooltipClass="conversation-tooltip-info">
  <ui-svg-icon svgIcon="inbox" size="medium"></ui-svg-icon>
  {{ 'smart_inbox.inbox_view.compose_minimized_bar.email_count' | translate:{ count: minimizedCount } }}
  <mat-icon>open_in_full</mat-icon>
</button>
